import React, { useRef } from 'react';

import { useOnClickOutside } from '@/components/utils';

import type { CombinedSuggestion } from './SearchForm';
import { StyledSuggestions } from './SearchForm.styled';
import { SuggestionItem } from './SuggestionItem';

interface ISuggestionListProps {
  query: string;
  suggestions: CombinedSuggestion[];
  focusedSuggestionIndex: number;
  handleClickOutside: () => void;
  handleSuggestionClick: (suggestion: CombinedSuggestion) => void;
  handleSuggestionMouseEnter: (index: number) => void;
  handleSuggestionMouseLeave: () => void;
}

export const SuggestionList = ({
  query,
  suggestions,
  focusedSuggestionIndex,
  handleClickOutside,
  handleSuggestionClick,
  handleSuggestionMouseEnter,
  handleSuggestionMouseLeave,
}: ISuggestionListProps) => {
  const suggestionsRef = useRef<HTMLUListElement | null>(null);

  useOnClickOutside(suggestionsRef, handleClickOutside);

  return (
    <StyledSuggestions ref={suggestionsRef}>
      {suggestions.map((suggestion, index) => (
        <SuggestionItem
          key={suggestion.id}
          query={query}
          suggestion={suggestion}
          isActive={index === focusedSuggestionIndex}
          handleSuggestionClick={() => handleSuggestionClick(suggestion)}
          handleSuggestionMouseEnter={() => handleSuggestionMouseEnter(index)}
          handleSuggestionMouseLeave={handleSuggestionMouseLeave}
        />
      ))}
    </StyledSuggestions>
  );
};
